"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackMaxEventAdded = exports.trackRemoveFromCollection = exports.trackAddToCollection = exports.trackCreateCollection = void 0;

var _actionTypes = require("./actionTypes");

var _constants = require("./constants");

var trackCreateCollection = function trackCreateCollection(id, category) {
  return {
    type: _actionTypes.CREATE_COLLECTION,
    meta: {
      analytics: {
        action: _constants.CREATE_COLLECTION_GA_ACTION,
        label: id,
        category: category
      }
    }
  };
};

exports.trackCreateCollection = trackCreateCollection;

var trackAddToCollection = function trackAddToCollection(id, category) {
  return {
    type: _actionTypes.ADD_EVENT_TO_COLLECTION,
    meta: {
      analytics: {
        action: _constants.ADD_TO_COLLECTION_GA_ACTION,
        label: id,
        category: category
      }
    }
  };
};

exports.trackAddToCollection = trackAddToCollection;

var trackRemoveFromCollection = function trackRemoveFromCollection(id, category) {
  return {
    type: _actionTypes.REMOVE_EVENT_FROM_COLLECTION,
    meta: {
      analytics: {
        action: _constants.REMOVE_FROM_COLLECTION_GA_ACTION,
        label: id,
        category: category
      }
    }
  };
};

exports.trackRemoveFromCollection = trackRemoveFromCollection;

var trackMaxEventAdded = function trackMaxEventAdded(id, category) {
  return {
    type: _actionTypes.REACH_MAX_LIMIT,
    meta: {
      analytics: {
        action: _constants.REACHED_MAX_EVENTS_GA_ACTION,
        label: id,
        category: category
      }
    }
  };
};

exports.trackMaxEventAdded = trackMaxEventAdded;
//# sourceMappingURL=analytics.js.map